import React from 'react';
import Fab from '@mui/material/Fab';
import CalculateIcon from '@mui/icons-material/Calculate';
import { Link as RouterLink } from 'react-router-dom';

const BackToCalculatorFab = () => (
  <Fab
    color="primary"
    component={RouterLink}
    to="/"
    aria-label="Back to calculator"
    sx={{
      position: 'fixed',
      bottom: 24,
      right: 24,
      zIndex: 1200,
      display: { xs: 'flex', sm: 'none' },
    }}
  >
    <CalculateIcon />
  </Fab>
);

export default BackToCalculatorFab;
